module.exports = ".list {\r\n    padding-bottom: 1px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/client-app/setting/setting.component.css
// module id = ./src/app/client-app/setting/setting.component.css
// module chunks = main